import { useParams,  } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import { useState } from "react";

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useAuth from '../../hooks/useAuth'

import ConfirmEmergency from './Partials/ConfirmEmergency';
import StepThree from './Partials/StepThree'
import StepFour from './Partials/StepFour'
import StepTwo from './Partials/StepTwo'
import StepOne from './Partials/StepOne'

const BookAssessment = () => {
  const { setShowLoader, auth } = useAuth();

  const axios = useAxiosPrivate();

  const [isValid, setIsValid] = useState(false);

  const [step, setStep] = useState(1)

  const [selectedAppointment, setSelectedAppointment] = useState({
    attributes: {}
  });
  
  const [selectedGP, setSelectedGP] = useState(null);
  const [contactDetails, setContactDetails] = useState(null);
  const [trigger, setTrigger] = useState(false)
  const [dependant, setDependant] = useState(null);


  const renderStep = () => {
    switch (step) {
      case 1:
        return <StepOne onValidityChange={setIsValid}/>;
      case 2:
        return <StepTwo setSelectedAppointment={setSelectedAppointment} selectedAppointment={selectedAppointment} setStep={setStep} onValidityChange={setIsValid} setDependant={setDependant} dependant={dependant} />
      case 3:
        return <StepThree selectedAppointment={selectedAppointment} selectedGP={selectedGP} setSelectedGP={setSelectedGP} setSelectedAppointment={setSelectedAppointment} setStep={setStep} setContactDetails={setContactDetails} onValidityChange={setIsValid} trigger={setTrigger} dependant={dependant} />
      case 4:
        return <StepFour selectedAppointment={selectedAppointment} selectedGP={selectedGP} contactDetails={contactDetails} setStep={setStep} onValidityChange={setIsValid} dependant={dependant} />
      default:
        return null;
    }
  }

  const RenderStepButton = () => {
    const buttonText = step === 4 ? 'Finish' : 'Next';
    const handleClick = async () => {
      if (step === 3) {
        setShowLoader(true);
        if(trigger)
          {
            try {
              await axios.post('/user/gp/update', {
                gp: selectedGP,
                id: auth?.user?.id,
              });
            } catch (error) {
              console.error('Error submitting GP info:', error);
              setShowLoader(false);
              return;
            }
          }
       
        // Continue to next step after request succeeds
        setStep((prev) => prev + 1);
        setIsValid(false);
        setShowLoader(false);
        return;
      }
    
      // For steps 1, 2, or 4
      setStep((prev) => prev + 1);
      setIsValid(false);
    };
    
  
    return (
      <>
        {step > 1 && (
          <button
            type="button"
            onClick={() => setStep(step - 1)}
            className="px-4 py-2 bg-gray-600 text-white rounded-md shadow-sm hover:bg-gray-700"
          >
            Back
          </button>
        )}
        <button
          type="button"
          onClick={handleClick}
          disabled={!isValid}
          className={`px-4 py-2 rounded-md shadow-sm text-white 
            ${!isValid
              ? 'bg-gray-300 cursor-not-allowed'
              : 'bg-portal-light hover:bg-portal-medium'}`}
        >
          {buttonText}
        </button>
      </>
    );
  };
  


  return (
    <section>
      <form  >
        <div className="flex items-center justify-center border-b border-gray-300 pb-4 mb-4">
          <ConfirmEmergency step={step} />
        </div>

        <div className="mb-8">
          {renderStep()}
        </div>

        {step !== 4 && (
          <div className={"flex items-center mb-4 " + (step > 1 ? 'justify-between' : 'justify-end')}>
            <RenderStepButton />
          </div>
        )}
      </form>
    </section>
  )
}

export default BookAssessment;